import { apiService } from './api';
import { ApiResponse } from '../types';

export interface Dimension {
  id: number;
  label: string;
  displayOrder: number;
  description?: string | null;
  metadata?: Record<string, any> | null;
  name?: string | null; // Legacy field
  createdAt?: string;
  updatedAt?: string;
}

export const dimensionService = {
  async getDimensions(): Promise<Dimension[]> {
    const response = await apiService.get<ApiResponse<{ dimensions: Dimension[] }>>('/dimensions');
    if (response.data?.dimensions) {
      return response.data.dimensions;
    }
    throw new Error(response.message || 'Failed to fetch dimensions');
  },

  async getDimension(id: number): Promise<Dimension> {
    const response = await apiService.get<ApiResponse<{ dimension: Dimension }>>(`/dimensions/${id}`);
    if (response.data?.dimension) {
      return response.data.dimension;
    }
    throw new Error(response.message || 'Failed to fetch dimension');
  },

  async reorderDimensions(orderedIds: number[]): Promise<void> {
    const response = await apiService.post<ApiResponse<void>>('/dimensions/reorder', { orderedIds });
    if (!response.success) {
      throw new Error(response.message || 'Failed to reorder dimensions');
    }
  },
};

